import './fonts.js';
import * as bootstrap from 'bootstrap';
import $ from "jquery";


//スクロールバーの幅
const setScrollbarWidth = () => {
	const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth
	document.documentElement.style.setProperty('--scrollbar', `${scrollbarWidth}px`);
};
window.addEventListener('load', setScrollbarWidth);
window.addEventListener('resize', setScrollbarWidth);


$(function () {
	$(window).on( 'load scroll', function () {
		const windowHeight = $(this).height();
		const scroll = $(this).scrollTop();

		//フェードアニメーション
		$('.mv-fadeUp').each(function () {
			const targetPosition = $(this).offset().top;
			if (scroll > targetPosition - windowHeight + 100) {
				$(this).addClass("fadeUp");
			}
		});

		//トップナビの表示
		const nav = $('#nav-wrapper');
		if (scroll > 400) {
			$(nav).addClass("active");
		}
		else {
			$(nav).removeClass("active");
		}

	});

	$( '#nav a[href^="#"]' ).on( 'click', function(){
		const target = $(this).attr('href');
		const scrollTop = $( target ).offset().top;
		$( window ).scrollTop( scrollTop-200 );
	});

});


